$(function() {
  function showAllCategories() {
    $('.resources-browse-by-category .home-product-category__card').addClass(
      'show'
    );
  }

  const categoryCards = $(
    '.resources-browse-by-category  .home-product-category__card'
  );

  categoryCards.each(function(index) {
    if (index + 1 <= 6) {
      $(this).addClass('show');
    }
  });

  $(document).on('click', '.see-more-btn', function(e) {
    e.preventDefault();
    $('.see-more-btn').hide();
    showAllCategories();
  });
});
